import type { LineCaption, LineDiagramStep, LineStationStep } from './LineDiagram'

/**
 * Authoring shorthand for the cities' hand-written rail diagrams
 * (`src/city/*LineDiagrams.ts`): each builds one or more `LineDiagramStep`s.
 */
export const DiagramSteps = Object.freeze({
  /** "<station> branch" caption. */
  branch: (...slugs: string[]): LineDiagramStep => ({ caption: { kind: 'branch', slugs } }),
  /** "via <station>" caption. */
  via: (...slugs: string[]): LineDiagramStep => ({ caption: { kind: 'via', slugs } }),
  /** "Loop" caption. */
  loop: { caption: { kind: 'loop' } satisfies LineCaption } as LineDiagramStep,
  /** A terminus that opens `rail`. */
  start: (rail: number, slug: string): LineStationStep => ({ slug, rail, op: 'start' }),
  /** A terminus that closes `rail`. */
  end: (rail: number, slug: string): LineStationStep => ({ slug, rail, op: 'end' }),
  /** Plain stops on `rail`, in order. */
  stops: (rail: number, ...slugs: string[]): LineStationStep[] =>
    slugs.map((slug) => ({ slug, rail })),
  /** A junction station: rails splitting off, merging in, or also stopping here. */
  at: (
    rail: number,
    slug: string,
    links: Pick<LineStationStep, 'split' | 'merge' | 'also'>,
  ): LineStationStep => ({ slug, rail, ...links }),
  /** `rail` returns to `slug`, already listed above (loop close / rejoin). */
  back: (rail: number, slug: string): LineDiagramStep => ({ loopClose: slug, rail }),
})
